import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { MpsPostLoginUrlHelper } from '../../mps/helpers/mps-post-login-url.helper';
import { MpsUserService } from '../../mps/services/mps-user.service';
import { applicationRouteNames } from '../application-route-names';

/**
 * Guard enforcing the onboarding gate on all protected application routes.
 * If an authenticated user has not yet completed onboarding (cgu_accepted_at is null),
 * they are redirected to the /welcome page regardless of the route they attempted.
 * Users who have completed onboarding, or unauthenticated users, pass through unchanged
 * (MpsLoggedInGuard handles unauthenticated cases on protected routes).
 *
 * The attempted route is re-captured on the way to /welcome so a deep link survives onboarding;
 * WelcomeComponent replays it after CGU acceptance.
 */
export const appOnboardingGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const user = inject(MpsUserService).getUser();

  if (user != null && user.cgu_accepted_at == null) {
    MpsPostLoginUrlHelper.capture(state.url);
    return router.navigateByUrl('/' + applicationRouteNames.welcome);
  }

  return true;
};
